import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { toast } from "sonner";
import { CheckCircle2, XCircle, Save } from "lucide-react";
import { api } from "../lib/api";

export default function ClaimVerify() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState("loading");
  const [biz, setBiz] = useState(null);
  const [form, setForm] = useState({});
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!token) { setState("error"); return; }
    api.verifyClaim(token)
      .then((d) => { setBiz(d.business); setForm({ phone: d.business.phone || "", website: d.business.website || "", address: d.business.address || "", hours: d.business.hours || "", description: d.business.description || "" }); setState("ok"); })
      .catch(() => setState("error"));
  }, [token]);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.editClaim({ token, ...form });
      toast.success("¡Datos actualizados!");
    } catch { toast.error("No se pudieron guardar los cambios."); } finally { setBusy(false); }
  };

  if (state === "loading") return <div className="py-24 text-center text-muted-foreground">Verificando...</div>;
  if (state === "error")
    return (
      <div className="flex flex-col items-center py-24 text-center">
        <XCircle className="h-12 w-12 text-rose-500" />
        <p className="mt-3 font-display text-xl font-bold">Enlace inválido o expirado</p>
        <Link to="/explorar" className="mt-4 rounded-full bg-brand px-5 py-2 text-sm font-bold text-white">Ir al directorio</Link>
      </div>
    );

  return (
    <div className="mx-auto max-w-lg px-4 py-8 sm:px-6">
      <div className="flex items-center gap-3 rounded-2xl border border-emerald-200 bg-emerald-50 p-4" data-testid="verify-success">
        <CheckCircle2 className="h-7 w-7 text-emerald-600" />
        <div>
          <p className="font-bold text-emerald-800">¡Negocio verificado!</p>
          <p className="text-sm text-emerald-700">Ahora eres el dueño verificado de {biz?.name}.</p>
        </div>
      </div>

      <h2 className="mt-6 font-display text-xl font-bold">Edita tus datos</h2>
      <form onSubmit={save} className="mt-4 space-y-3">
        <Field label="Teléfono" value={form.phone} onChange={set("phone")} testid="edit-phone" />
        <Field label="Sitio web" value={form.website} onChange={set("website")} testid="edit-website" />
        <Field label="Dirección" value={form.address} onChange={set("address")} testid="edit-address" />
        <Field label="Horario" value={form.hours} onChange={set("hours")} testid="edit-hours" />
        <div>
          <label className="mb-1 block text-xs font-semibold text-muted-foreground">Descripción</label>
          <textarea data-testid="edit-description" value={form.description} onChange={set("description")} rows={3} className="w-full rounded-xl border border-input bg-white px-3 py-2 outline-none focus:ring-2 focus:ring-brand/40" />
        </div>
        <button data-testid="save-claim-edit" disabled={busy} className="inline-flex h-12 w-full items-center justify-center gap-2 rounded-full bg-brand font-bold text-white hover:bg-brand-hover disabled:opacity-60">
          <Save className="h-4 w-4" /> {busy ? "Guardando..." : "Guardar cambios"}
        </button>
      </form>
    </div>
  );
}

const Field = ({ label, testid, ...rest }) => (
  <div>
    <label className="mb-1 block text-xs font-semibold text-muted-foreground">{label}</label>
    <input data-testid={testid} {...rest} className="h-11 w-full rounded-xl border border-input bg-white px-3 outline-none focus:ring-2 focus:ring-brand/40" />
  </div>
);
